var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "leftpane m-2" }, [
    _c(
      "ul",
      { staticClass: "ontology-small" },
      _vm._l(_vm.ontologies, function(ontology, key) {
        return _c(
          "li",
          { key: key, staticClass: "ontology-list my-4" },
          [
            _c(
              "router-link",
              {
                staticClass: "ontology-small-title",
                attrs: {
                  to: { name: "ontology", params: { ontology: ontology.id } }
                }
              },
              [_vm._v(" " + _vm._s(ontology.name))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "top-terms" },
              [
                _vm._v("\n            Top concepts:\n            "),
                _vm._l(ontology.topConcepts, function(concept, key) {
                  return _c("div", { key: key, staticClass: "top-term" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(concept.concept.label) +
                        "\n            "
                    )
                  ])
                })
              ],
              2
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-843a8ce8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-843a8ce8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OntologiesLeftPane.vue
// module id = null
// module chunks = 